import auth from "./auth";

const index = {
  auth,
};

export default index;
